import { Component, OnInit } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { WorkerFile } from '../_types/worker-file';
import { WorkersService } from '../_services/workers.service';
import { firstValueFrom } from 'rxjs';
import { WorkersFilesService } from '../_services/workers-files.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { FilesService } from '../../common/_services/files.service';
import { File } from 'src/app/modules/common/_types/file';
import { WorkerFileType } from '../_types/worker-file-type';
import { WorkersFilesTypesService } from '../_services/workers-files-types.service';
import { LoginService } from '../../login/login.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';

@Component({
    selector: 'app-workers-file',
    templateUrl: './workers-file.component.html',
    styleUrls: ['./workers-file.component.css'],
    standalone: false
})
export class WorkersFileComponent implements OnInit {
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public workerFileFormGroup!: RxFormGroup;

  public workerFile: WorkerFile = new WorkerFile();
  public typeOfBusiness: string = 'Person';

  public files: any[] = [];
  public workerFileTypes: WorkerFileType[] = [];

  constructor(
    private formBuilder: RxFormBuilder,
    private config: DynamicDialogConfig,
    private workerFileService: WorkersFilesService,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private formValidationService: FormValidatorService,
    private filesService: FilesService,
    private workerFileTypesService: WorkersFilesTypesService,
    private loginService: LoginService
  ) {
    this.workerFileFormGroup = this.formBuilder.formGroup(WorkerFile) as RxFormGroup;
  }

  async ngOnInit() {
    let workerFileId = this.config.data.workerFileId;
    this.typeOfBusiness = this.config.data.typeOfBusiness;
    if (workerFileId) {
      await this.loadWorkerFile(workerFileId);
    } else {
      this.workerFile.workerId = this.config.data.workerId;
      this.workerFileFormGroup.patchValue(this.workerFile);
    }
    this.allowWrite = this.loginService.hasPermission("WORKERS.WRITE");
    this.allowDelete = this.loginService.hasPermission("WORKERS.DELETE");
    this.loadWorkerFileTypes();
  }

  async loadWorkerFile(workerFileId: string) {
    this.workerFile = await firstValueFrom(this.workerFileService.get(workerFileId));
    this.workerFileFormGroup.patchValue(this.workerFile);
  }

  async loadWorkerFileTypes(){
    let filter: any = {
      typeOfBusiness: new Filter(FilterOperation.equals, 'typeOfBusiness','', this.typeOfBusiness)
    };
    let params:IParamsCollection = {
      sort: ['name'],
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.workerFileTypesService.all(params));
    this.workerFileTypes = response.data;
  }

  async onFileSelect(event: any) {
    let files = event.files;
    for (let file of files) {
      this.files.push(file);
    }
  }

  async typeChange(){
    let workerFileTypeId = this.workerFileFormGroup.get('workerFileTypeId')?.value;
    if(workerFileTypeId==null) return;
    let workerFileType = this.workerFileTypes.find(x => x.id == workerFileTypeId);
    if(workerFileType){
      this.workerFileFormGroup.patchValue({name: workerFileType.name});

      //calcular fecha de expiración
      if(workerFileType.daysToExpire){
        let expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + workerFileType.daysToExpire);
        this.workerFileFormGroup.patchValue({expirationDate: expirationDate});
      }
    }
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.workerFileFormGroup);
    if (valid && (this.files.length > 0 || this.workerFile.fileId)) {

      if(this.workerFile.expirationDate != this.workerFileFormGroup.get('expirationDate')?.value){
        //Ha cambuado la fecha de expiration, se actualiza el 
        
        this.workerFileFormGroup.patchValue({processedExpiration: false});
      }
      this.workerFile = Object.assign(this.workerFile, this.workerFileFormGroup.value);

      if (this.files.length > 0) {
        try {
          for (let file of this.files) {
            let data: File = new File();
            data.fileName = file.name;
            data.size = file.size;
            data.contentType = file.type;
            if(data.contentType=='') data.contentType = 'application/octet-stream';
            //data.path = file.name;

            //creamos el file
            let fileResponse = await firstValueFrom(
              this.filesService.save(data)
            );

            //subimos el fichero al file
            let response = await firstValueFrom(this.filesService.upload(fileResponse.id as string, file));

            //guardamos el file en el worker
            this.workerFile.fileId = fileResponse.id as string;
            await firstValueFrom(this.workerFileService.save(this.workerFile));
          }
        } catch (error) {
          this.messageService.add({
            closable: true,
            severity: 'severity',
            summary: 'Error',
            detail: 'Error al guardar los ficheros.',
          });
        }
      } else {
        //guardamos el file en el expediente
        await firstValueFrom(this.workerFileService.save(this.workerFile));
      }

      this.messageService.add({
        closable: true,
        severity: 'success',
        summary: 'Éxito',
        detail: 'Ficheros guardados correctamente.',
      });
      this.dynamicDialogRef.close();

    } else {

      this.messageService.add({
        closable: true,
        severity: 'error',
        summary: 'Error',
        detail: 'Existen errores, por favor revise el formulario de datos.',
      });
      
    }
  }
}
